// extracted by mini-css-extract-plugin
export var animationContainer = "_jz-0";
export var footer = "_jz-1";
export var gray = "_jz-2";
export var lineItem = "_jz-3";
export var lineItemImage = "_jz-4";
export var lineItemInfo = "_jz-5";
export var lineItemText = "_jz-6";
export var lineItems = "_jz-7";
export var modalContent = "_jz-8";
export var options = "_jz-9";
export var orderName = "_jz-a";
export var refundAmount = "_jz-b";